import { Icon } from "../common/icons";
import { AnswerProduct } from "./answerProduct";

export default function SelectedResource(props) {

    const { setResourceSelected, resourceSelected } = props;

    return(

    <div className="gpt-message__assistant--citations-wide gpt-message__assistant--citations gpt-message__assistant--citations-lp">
        <div className="gpt-message__product">
            <div className="gpt-message__product--back" onClick={() => setResourceSelected(null)}>
                <Icon name="arrow-left2" customClass="icon--medium" />
                <div className="ai-body-medium ai-grey-100">Back</div>
            </div>
            <AnswerProduct resourceId = {resourceSelected.id} resource={resourceSelected}/>


        </div>
    </div>
    )

}